export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10127.13a33fc4.jpg";